
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants/constants';
import { DsconfigService, StorageService } from '@services/services.module';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private admin: any;
  private direction: any;

  constructor(
    private dsConfig: DsconfigService,private storage: StorageService,private http: HttpClient
  ) {}

  exportExcel(url: string, params?: any) {
    console.log("empezando con nuevo método");
    let headerEmail = this.storage.get(Constants.UserData.email) || '';
    let headerProfileId = this.storage.get(Constants.UserData.profileId) || '';
    let headerEmployeeNumber = this.storage.get(Constants.UserData.employeeNumber) || '';
    let headerEmployeeName = this.storage.get(Constants.UserData.employeeName) || '';

    console.log("url",url);
    let headers = new HttpHeaders();
    if (headerEmail) headers = headers.set('email', headerEmail);
    if (headerProfileId) headers = headers.set('profileId', headerProfileId);
    if (headerEmployeeNumber) headers = headers.set('employeeNumber', headerEmployeeNumber);
    if (headerEmployeeName) headers = headers.set('name', headerEmployeeName);

    // console.log("headers",headers);
    console.log("params",params);

    try
    {
      this.http
      .get(url, { headers, params, responseType: 'blob', observe: 'response' }) // Response as blob
      .pipe(
        catchError((error) => {
          console.error('Error occurred while exporting Excel:', error);
          return throwError(() => new Error('Failed to export Excel'));
        })
      )
      .subscribe((response) =>
      {
        let filename = 'export.xlsx'; // Default filename
        console.log("response.headers",response.headers);
        const contentDisposition = response.headers.get('Content-disposition');
        console.log("contentDisposition",contentDisposition);
        const matches = /filename="(.+)"/.exec(contentDisposition);
        if (matches != null && matches[1])
        {
          filename = matches[1];
        }


        const blob = new Blob([response.body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' });
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = filename; // File name
        link.click();
      });
    } catch (error)
    {
      console.error('An unexpected error occurred:', error);
    }
  }

  getRecognitionReportForAdmin(month: any, year: any): void {
    this.admin = {
      'admin': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/recognition/administration'//?month=' + month + '&year=' + year
    };
    const params = {
      month: month,
      year: year,
    };
    this.exportExcel(this.admin.admin, params);
    //window.open(this.admin.admin, '_blank');

  }

  getRecognitionReportForDirection(month: any, year: any): void {
    this.direction = {
      'direction': this.dsConfig.getUrlBase() + '/ess/v1/export/excell/recognition/management'//?month=' + month + '&year=' + year
     };

     const params = {
      month: month,
      year: year,
    };

    this.exportExcel(this.direction.direction, params);
     //window.open(this.direction.direction, '_blank');
  }
}
